import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const DayNightBlindsPage = lazy(() => import('../pages/day-night-blinds/page'));
const PerfectFitBlindsPage = lazy(() => import('../pages/perfect-fit-blinds/page'));
const PleatedBlindsPage = lazy(() => import('../pages/pleated-blinds/page'));
const FauxWoodBlindsPage = lazy(() => import('../pages/faux-wood-blinds/page'));
const RealWoodBlindsPage = lazy(() => import('../pages/real-wood-blinds/page'));
const RollerBlindsPage = lazy(() => import('../pages/roller-blinds/page'));
const VerticalBlindsPage = lazy(() => import('../pages/vertical-blinds/page'));
const VenetianBlindsPage = lazy(() => import('../pages/venetian-blinds/page'));
const ShuttersPage = lazy(() => import('../pages/shutters/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/day-night-blinds',
    element: <DayNightBlindsPage />,
  },
  {
    path: '/perfect-fit-blinds',
    element: <PerfectFitBlindsPage />,
  },
  {
    path: '/pleated-blinds',
    element: <PleatedBlindsPage />,
  },
  {
    path: '/faux-wood-blinds',
    element: <FauxWoodBlindsPage />,
  },
  {
    path: '/real-wood-blinds',
    element: <RealWoodBlindsPage />,
  },
  {
    path: '/roller-blinds',
    element: <RollerBlindsPage />,
  },
  {
    path: '/vertical-blinds',
    element: <VerticalBlindsPage />,
  },
  {
    path: '/venetian-blinds',
    element: <VenetianBlindsPage />,
  },
  {
    path: '/shutters',
    element: <ShuttersPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;